import React, { useEffect, useMemo, useState } from 'react'
import Box from '@mui/material/Box'
import LinearProgress from '@mui/material/LinearProgress'

interface Props {
    onComplete: () => void,
    duration: number
}
export default function Hourglass({ onComplete, duration }: Props) {
    const [progress, setProgress] = useState(0)
    const [started, setStarted] = useState(true)
    const timingPerStep : number = useMemo(() => {
        const totalDuration = duration * 1000;
        const timingPerStep = totalDuration / 100; // 100 steps
        return timingPerStep;
    }, [duration])

    // info('Hourglass', { started, timingPerStep, duration })
    useEffect(() => {
        if (started) {
            const timer = setInterval(() => {
                setProgress((oldProgress) => {
                    if (oldProgress === 100) {
                        onComplete()
                        return 0
                    }
                    // const diff = Math.random() * 10;
                    const diff = 1
                    return Math.min(oldProgress + diff, 100)
                })
            }, timingPerStep)

            return () => {
                clearInterval(timer)
            }
        }
    }, [started, timingPerStep, onComplete])

    return (
        <Box sx={{ width: '100%', marginTop: 5, marginBottom: 5 }} onClick={() => setStarted(s => !s)}>
            <LinearProgress variant="determinate" value={progress} />
        </Box>
    )
}
